<div class="loading d-block justify-content-center" >
  <div class="spinner-border" style="color: #8d0528;" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/platform/lead/nested-loader/nested-loader.component.html